import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from 'antd';
import React from 'react';

interface CardsProps {
    title?: string;
    desc: string;
    url: IconProp;
}

const { Meta } = Card;

const Cards: React.FC<CardsProps> = ({ title, desc, url }) => (
    <Card
        hoverable
        className="text-center p-6"
        style={{ width: 300 }}
        cover={<div className="flex justify-center items-center" >
            <FontAwesomeIcon icon={url} style={{ color: "#00B0F0", fontSize: "4rem" }} />
        </div>}
        bordered={false}
    >
        <Meta title={title} />
        <p className='text-sm text-gray-400 text-center mt-4'>{desc}</p>
    </Card>
);

export default Cards;
